/* eslint-disable max-len */
import React, { useState, useEffect } from "react"
import { FiRss } from "react-icons/fi"
import createPersistedState from "use-persisted-state"
import HoverMenu from "~components/HoverMenu"

import { Link } from "gatsby"
import Entry from "./Entry"

import * as style from "./Bell.module.scss"

const Bell = ({ entries, microcopy }) => {
  const usePersistedState = createPersistedState(
    "com.box.developer.changelog.last_shown_at",
  )
  const [lastShownAt] = usePersistedState(null)
  const [hasNew, setHasNew] = useState(false)

  useEffect(() => {
    if (!entries?.[0]) {
      return
    }
    const hasNewEntries = Date.parse(entries[0].frontmatter.published_at) > Date.parse(lastShownAt)
    setHasNew(hasNewEntries)
  }, [lastShownAt, entries])

  return (
    <div className={style.bell} data-has-new={hasNew}>
      <Link
        to="/changelog/"
        activeClassName={style.active}
        className={style.link}
      >
        <svg width="20" height="22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.653 2.6v.593l.577.137c1.268.3 2.302.956 3.029 1.982.731 1.033 1.19 2.501 1.19 4.488v3.588c0 .507.176 1.005.425 1.412.25.407.613.786 1.058 1.012l.002.001.128.065.006.003c.4.198.59.485.685.726a1.447 1.447 0 0 1 .097.407v.436H1.15v-.438c.005-.097.066-.78.789-1.143l.001-.001.125-.062.002-.001c.446-.223.808-.606 1.056-1.009.248-.404.427-.902.427-1.407V9.8c0-2.019.376-3.485 1.058-4.507.667-1 1.68-1.655 3.144-1.959l.598-.124V2.6c0-.903.75-1.65 1.654-1.65.902 0 1.65.745 1.65 1.65Zm-.183 17.55a1.65 1.65 0 0 1-2.94 0h2.94Z" stroke="currentColor" strokeWidth="1.5" /></svg>
      </Link>
      <HoverMenu right wide>
        <ul>
          <li className={style.indexLink}>
            <Link to="/changelog/">
              {microcopy.text("changelog.title", "Developer Changelog")}
              <FiRss />
            </Link>
          </li>
          {entries.map((entry) => (
            <li key={entry.id} className={style.entry}>
              <Entry entry={entry} microcopy={microcopy} />
            </li>
          ))}
        </ul>
      </HoverMenu>
    </div>
  )
}

export default Bell
